<template>
  <div class="header">
    <div class="contant">
      <div>
        <span class="el-dropdown-link">
          <div class="logoUnit">
            <img
              src="../assets/img/2234.svg"
              class="logo"
              alt
              ondragstart="return false;"
            />
            <span class="shuxian">|</span>
            <span class="titleType">超爽整理工具</span>
            <!-- <img src="../assets/img/dropDownT.svg" alt class="downIcon" ondragstart="return false;" /> -->
          </div>
        </span>
      </div>

      <div class="infoList">
        <div class="guide" @click="openVideo" ref="selectLi">
          <img
            src="../assets/img/video-create.svg"
            alt
            ondragstart="return false;"
          />
          <span>教学视频</span>
        </div>
        <!-- v-if="rightHeader" -->
        <template>
          <el-dropdown>
            <span class="el-dropdown-link">
              <div class="userInfo">
                <img
                  :src="userInfo.avatar"
                  alt
                  class="headerImg"
                  @load="imgLoad"
                  ondragstart="return false;"
                />
                <p v-if="userInfo.name" class="nameNick">{{ userInfo.name }}</p>
                <p class="nameNick" v-else></p>

                <div class="transfromDiv">
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item>
                      <div class="tapItem" @click="openMask(1)">
                        <img
                          src="../assets/img/popup-shareMin.svg"
                          alt
                          style="
                            margin-right: 14px;
                            width: 24px;
                            height: 24px;
                            vertical-align: middle;
                            margin-top: -4px;
                          "
                        />
                        <span>我的小程序控制台</span>
                      </div>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <div class="tapItem" @click="openMask(3)">
                        <img
                          src="../assets/img/t1.svg"
                          alt
                          style="
                            margin-right: 14px;
                            margin-left: 3px;
                            width: 20px;
                            height: 20px;
                            vertical-align: middle;
                            margin-top: -4px;
                          "
                          ondragstart="return false;"
                        />
                        <span>退出</span>
                      </div>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </div>
              </div>
            </span>
          </el-dropdown>
        </template>
      </div>
    </div>

    <!-- 视频的提示 -->
    <transition name="el-zoom-in-top">
      <div
        class="openVideoTip"
        :style="{
          top: offsetHeight + 10 + 'px',
          left: offsetLeft - 10 + 'px',
        }"
        v-show="tipStatus"
      >
        不会用点这里哦
      </div>
    </transition>

    <!-- 退出和二维码的弹窗 -->
    <div class="maskOut" v-if="maskStatus != 0">
      <!-- 退出弹框 -->
      <div class="outMask" v-if="maskStatus == 3">
        <!-- <div class="outClose">
          <img src="../assets/img/stepsClose.svg" alt @click="openMask(0)" />
        </div> -->

        <div>
        <p class="titleP">是否退出?</p>
        <p class="titleG">退出后，未同步的作品会丢失，已同步的作品可以在小程序中找到。</p>
        </div>

        <div class="btnMoni">
          <div class="noOut" @click="close">退出</div>
          <div class="okOut" style="margin-top:10px" @click="openMask(0)">暂不退出</div>
        </div>
      </div>

      <!-- 问题反馈二维码弹框 -->
      <div class="qrCodeView" v-if="maskStatus == 2">
        <div class="closeIcon">
          <p>提交反馈</p>
          <img src="../assets/img/stepsClose.svg" alt @click="openMask(0)" />
        </div>
        <div class="qrCodeImg">
          <img :src="problemQrcode" alt />
        </div>
        <p>微信扫码提交反馈</p>
      </div>

      <!-- 我的作品二维码弹框 -->
      <div class="qrCodeView" v-if="maskStatus == 1">
        <div class="closeIcon">
          <img src="../assets/img/stepsClose.svg" alt @click="openMask(0)" />
        </div>
        <!-- <div class="closetitle">
          <p>我的小程序控制台</p>
        </div> -->
        <div class="qrCodeImg1">
          <div class="qrCodeImg" >
            <img :src="xcxQrcode" alt />
          </div>
          <p class="p1" style="margin-top:30px">微信扫一扫</p>
          <p class="p1">打开我的小程序控制台</p>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { xcxQrcode, userInfo, userallInfo } from "@/request/api";

export default {
  name: "transferHeader",
  props: {
    tipStatus: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dropDownTap: false,
      userInfo: {},
      rightHeader: false,
      maskStatus: 0, //打开弹窗 0:关闭  1，我的作品   2，提交问题
      offsetHeight: 0,
      offsetLeft: 0,
    };
  },
  mounted() {
    var that = this;
    this.getUserInfo();
    this.getQrcode();
    setTimeout(function () {
      that.elementLocation();
    }, 1000);
  },
  methods: {
    // 获取元素位置信息
    elementLocation() {
      this.offsetLeft = this.$refs.selectLi.offsetLeft;
      this.offsetHeight = this.$refs.selectLi.offsetHeight;
      console.log(this.offsetLeft, this.offsetHeight);
    },

    // 获取个人信息
    getUserInfo() {
      var that = this;
      console.log("999999999999999999999999999999999999999999");
      userallInfo().then((res) => {
        console.log(res,'res')
        that.userInfo = res.data.data.photographer
      });
    },

    imgLoad() {
      this.rightHeader = true;
    },

    // 获取各种二维码
    getQrcode() {
      const data = {
        path: "subPage/feedBack/feedBack",
        width: 280,
      };
      // 问题二维码
      xcxQrcode(data).then((res) => {
        const blob = new Blob([res.data]);
        const url = window.URL.createObjectURL(blob);
        this.problemQrcode = url;
      });

      // 我的作品二维码
      const params = {
        path: "pages/homePage/homePage",
        width: 202,
      };
      xcxQrcode(params).then((res) => {
        const blob = new Blob([res.data]);
        const url = window.URL.createObjectURL(blob);
        this.xcxQrcode = url;
      });
    },
    // 有关下拉框的事件
    openMask(e) {
      this.maskStatus = e;
    },

    // 切换交付
    switchJiaofu() {
      var that = this;
      this.$router.push({
        path: "/userHome",
      });
    },

    // 退出
    close() {

      console.log('close')
      // this.$router.push({
      //   path: "/",
      // });

      // this.$router.push({
      //   path: "/"
      // });
      var url = ''
    
      if (process.env.NODE_ENV === 'production') 
      {
        url = window.location.origin
      }
      else
      {
        url = window.location.origin + '/home'
      }

      console.log('close-url',url)
      window.location.href = url
    },

    openVideo() {
      this.$emit("openVideo");
    },

    // 点击Logo,回到tab页
    goTab() {
      this.$router.push({
        path: "/tab",
      });
    },
  },
};
</script>

<style lang="less" scoped>
.header {
  height: 60px;
  background: #fff;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
  .contant {
    width: 90%;
    // min-width: 1300px;
    height: 100%;
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .logoUnit {
      display: flex;
      align-items: center;
      // cursor: pointer;
      height: 60px;
      .logo {
        width: 84px;
        height: 26px;
        display: inline-block;
        vertical-align: middle;
      }

      .shuxian {
        font-size: 16px;
        margin: 0px 10px 0px 12px;
        color: #000;
        margin-top: -3px;
      }

      .titleType {
        font-size: 18px;
        color: #000;
        margin-top: -2px;
      }

      .downIcon {
        vertical-align: middle;
        width: 10px;
        height: 10px;
        margin-left: 10px;
      }
    }
    .infoList {
      display: flex;
      align-items: center;
      .funcItem {
        margin-left: 15px;
        font-size: 12px;
        color: #333333;
      }
      .guide {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        margin-right: 30px;
        color: rgba(51, 51, 51, 1);
        height: 60px;
        display: flex;
        align-items: center;
        cursor: pointer;
        img {
          vertical-align: middle;
          margin-right: 6px;
          width: 24px;
          height: 24px;
        }
        span {
          margin-top: 1px;
        }
      }
      .userInfo {
        font-size: 15px;
        color: #000;
        height: 60px;
        display: flex;
        align-items: center;
        position: relative;
        cursor: pointer;
        .nameNick {
          // width: 100px;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
        .headerImg {
          width: 32px;
          height: 32px;
          border-radius: 50%;
          margin-right: 12px;
        }
        .dropDownT {
          margin-left: 5px;
        }
        .transfromDiv {
          .dropDownTap {
            width: 110px;
            height: 112px;
            background: rgba(255, 255, 255, 1);
            box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.14);
            border-radius: 8px;
            position: absolute;
            left: 0;
            top: 56px;
            padding: 10px 0px 10px 14px;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            .tapItem {
              display: flex;
              align-items: center;
              font-size: 20px;
              img {
                margin-right: 14px;
              }
            }
          }
        }
      }
      .outDiv {
        font-size: 12px;
        color: #333333;
      }
    }
  }
}

.openVideoTip {
  background: #000;
  width: 120px;
  height: 35px;
  text-align: center;
  line-height: 35px;
  border-radius: 30px;
  position: absolute;
  color: #ffffff;
}

.maskOut {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.9);
  z-index: 9999999 !important;
  display: flex;
  justify-content: center;
  align-items: center;
  .outMask {
    width: 420px;
    height: 260px;
    background: #fff;
    border-radius: 20px;
    position: absolute;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 30px 20px;
    .outClose {
      position:absolute;
      right: 20px;
      top: 30px;
      img {
        width: 14px;
        height: 14px;
      }
    }
    .titleP {
      font-size: 22px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 800;
      color: rgba(0, 0, 0, 1);
      line-height: 30px;
      // text-align: center;
      text-align: left;
      margin-top: 0px;
    }
    .titleG {
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      line-height: 24px;
      margin-top: 8px;
      color: rgba(0, 0, 0, 0.4);
      // text-align: center;
      text-align: left;
    }
    .btnMoni {
      .noOut {
        height: 60px;
        border-radius: 60px;
        background: rgba(0, 0, 0, 1);
        text-align: center;
        justify-content: center;
        line-height: 60px;
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        cursor: pointer;
      }
      .okOut {
        height: 60px;
        border-radius: 60px;
        background: rgba(0, 0, 0, 0.05);
        text-align: center;
        justify-content: center;
        line-height: 60px;
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.6);
        cursor: pointer;
      }
    }
  }

  .qrCodeView {
    width: 420px;
    // height: 500px;
    background: #ffffff;
    border-radius: 20px;
    padding:30px 20px;
    display: flex;
    flex-direction: column;
    // justify-content: flex-start;
    align-items: end;
    .closeIcon {
      // position: absolute;
      top:0;
      right:0;
      cursor: pointer;
      img {
        width: 14px;
        height: 14px;
      }
    }
    .closetitle {
      width: 100%;
      height: 30px;
      p {
        text-align: left;
        font-size: 22px;
        line-height: 30px;
        font-family: PingFang SC;
        font-weight: 800;
        color: rgba(0, 0, 0, 1);
      }
    }
    .qrCodeImg1 {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 60px 0;
      img {
        width: 220px;
        height: 220px;
      }
    }
    .qrCodeImg {
      height: 220px;
      img {
        width: 220px;
        height: 220px;
      }
    }
    .p1 {
      font-size: 18px;
      line-height: 30px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      // margin-top: 30px;
      text-align: center;
    }
  }
}
</style>

<style>
span {
  font-family: PingFang SC;
  font-size: 15px;
  margin-top: 10px;
}

.el-dropdown-menu__item:not(.is-disabled):hover {
  background-color: #f7f7f7 !important;
  color: #000000 !important;
}
</style>